import Map from 'ol/Map.js';
import View from 'ol/View.js';
import Feature from 'ol/Feature.js';
import Overlay from 'ol/Overlay.js';
import TileLayer from 'ol/layer/Tile.js';
import VectorLayer from 'ol/layer/Vector.js';
import OSM from 'ol/source/OSM.js';
import VectorSource from 'ol/source/Vector.js';
import Point from 'ol/geom/Point.js';
import CircleGeometry from 'ol/geom/Circle.js';
import Fill from 'ol/style/Fill.js';
import Icon from 'ol/style/Icon.js';
import Stroke from 'ol/style/Stroke.js';
import Style from 'ol/style/Style.js';
import CircleStyle from 'ol/style/Circle.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import ScaleLine from 'ol/control/ScaleLine.js';
import { defaults as controlDefaults } from 'ol/control/defaults.js';
import DragPan from 'ol/interaction/DragPan.js';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom.js';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom.js';
import { defaults as interactionDefaults } from 'ol/interaction/defaults.js';
import { fromLonLat, toLonLat } from 'ol/proj.js';

export const ol = {
  Feature,
  Map,
  Overlay,
  View,
  control: {
    ScaleLine,
    defaults: { defaults: controlDefaults }
  },
  geom: {
    Circle: CircleGeometry,
    Point
  },
  format: {
    GeoJSON,
  },
  interaction: {
    DoubleClickZoom,
    DragPan,
    MouseWheelZoom,
    defaults: { defaults: interactionDefaults }
  },
  layer: {
    Tile: TileLayer,
    Vector: VectorLayer
  },
  proj: {
    fromLonLat,
    toLonLat
  },
  source: {
    OSM,
    Vector: VectorSource
  },
  style: {
    Circle: CircleStyle,
    Fill,
    Icon,
    Stroke,
    Style
  }
};
